// extracted by mini-css-extract-plugin
export default {"request-by-date_container":"request-by-date_container_s0H73m98","order-information__request-date--print":"order-information__request-date--print_TOHCYqI2"};